/* ============================================================
   SAJ · CLIENT REVIEW FIXES, PART 2 — cart, login, SEO
   Loaded from snippets/saj-head.liquid, after saj-fixes.js.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sajFixes2) return;
  window.__sajFixes2 = true;

  /* ============================================================
     E1 · "Remove sometimes doesn't work"

     Three faults in the original cart drawer, all of which look like
     "remove did nothing":

     1. The drawer sets .loading before the request and only clears it in
        .then(). One failed or 422 response leaves the drawer stuck in the
        loading state, and every later click is dead until a reload.
     2. There is no error branch at all, so a rejected change is silent.
     3. Rows carry the line POSITION in an inline onclick. If the drawer
        markup is ever a step behind the real cart, that position points at
        the wrong line — or at a line that no longer exists.

     Fix: intercept in the capture phase (so the inline onclick never runs),
     target the line by its immutable line-item key, always clear the loading
     state, and re-render from a fresh /cart.js.
     ============================================================ */

  var CART_ROOT = '[data-saj-cart]';

  function cartEl() { return document.querySelector(CART_ROOT) || document.querySelector('.saj-cart'); }

  function setLoading(on) {
    var c = cartEl();
    if (!c) return;
    c.classList[on ? 'add' : 'remove']('loading');
  }

  function rerender(data) {
    if (window.SAJ && typeof SAJ.refreshCart === 'function') {
      // refreshCart re-fetches /cart.js and repaints — the safest repaint we have.
      SAJ.refreshCart(false);
      return;
    }
    if (data) location.reload();
  }

  function rowTitle(row) {
    var h = row && row.querySelector('h5');
    return h ? h.textContent.trim() : '';
  }

  /* Resolve the line-item key for a row, even when the markup came from the
     header's own renderer (which only writes the position). */
  function resolveKey(row, cart) {
    if (!row) return null;
    var key = row.getAttribute('data-key');
    if (key) return key;
    if (!cart || !cart.items) return null;
    var idx = parseInt(row.getAttribute('data-line'), 10);
    var title = rowTitle(row);
    // Trust the position only if the product sitting there still matches.
    if (idx > 0 && cart.items[idx - 1]) {
      var candidate = cart.items[idx - 1];
      if (!title || (candidate.product_title || '').trim() === title) return candidate.key;
    }
    // Otherwise find it by title.
    for (var i = 0; i < cart.items.length; i++) {
      if ((cart.items[i].product_title || '').trim() === title) return cart.items[i].key;
    }
    return null;
  }

  function changeByKey(key, qty) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart change failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        setLoading(false);
        rerender(data);
      })
      .catch(function () {
        // Never leave the drawer stuck. Re-sync from the server so the user
        // sees the real cart rather than a frozen one.
        setLoading(false);
        rerender(null);
      });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-saj-qty], .saj-ci .rm, .saj-ci .saj-qty button');
    if (!el) return;
    var row = el.closest('.saj-ci');
    if (!row) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var declaredKey = el.getAttribute('data-saj-qty');
    var declaredQty = el.getAttribute('data-qty');

    if (declaredKey && declaredQty !== null) {
      changeByKey(declaredKey, parseInt(declaredQty, 10));
      return;
    }

    // Legacy row rendered by the header script: work out the key and the
    // intended quantity ourselves.
    var isRemove = el.classList.contains('rm');
    var qtySpan = row.querySelector('.saj-qty span');
    var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
    var target;
    if (isRemove) {
      target = 0;
    } else {
      var label = (el.getAttribute('aria-label') || '') + el.textContent;
      target = /decrease|−|-/i.test(label) ? current - 1 : current + 1;
    }
    if (target < 0) target = 0;

    setLoading(true);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var key = resolveKey(row, cart);
        setLoading(false);
        if (!key) { rerender(null); return; }
        changeByKey(key, target);
      })
      .catch(function () { setLoading(false); rerender(null); });
  }, true); // capture — beats the inline onclick

  /* A stuck .loading class from any other code path shouldn't survive either. */
  document.addEventListener('DOMContentLoaded', function () { setLoading(false); });

  /* ============================================================
     A5 · Make the login option obvious.
     Customer accounts are enabled (optional), but the header only shows a
     bare silhouette icon with no label, so it doesn't read as "sign in".
     ============================================================ */
  function labelAccount() {
    var a = document.querySelector('.saj-header .saj-hicon[aria-label="Account"]');
    if (!a || a.querySelector('.saj-hlabel')) return;
    var s = document.createElement('span');
    s.className = 'saj-hlabel';
    s.textContent = 'Login';
    a.appendChild(s);
  }
  labelAccount();

  /* ============================================================
     B3 · Organisation structured data, emitted once per page.
     Product and collection pages already carry their own JSON-LD from the
     section templates; the shop-level block was missing.
     ============================================================ */
  function orgSchema() {
    if (document.getElementById('saj-org-ld')) return;
    var data = {
      '@context': 'https://schema.org',
      '@type': 'JewelryStore',
      name: 'Sri Anu Jewellers',
      url: 'https://srianujewellers.com',
      description: 'Customized gold, silver, diamond and platinum jewellery from Madurai — BIS 916 hallmarked, priced on live rates, crafted by karigar families and shipped insured across India.',
      telephone: '+91 93636 05862',
      email: 'onlinesales@srianujewellers.com',
      areaServed: 'IN',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '121, Netaji Road, Madurai Main',
        addressLocality: 'Madurai',
        addressRegion: 'Tamil Nadu',
        postalCode: '625001',
        addressCountry: 'IN'
      }
    };
    var s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'saj-org-ld';
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  }
  orgSchema();
})();
